import React, { ReactElement } from 'react';
import { ServerSideInitProps } from 'types/types';
import { getGlobalProps } from 'utils/helpers/server/serverSideProps/global';
import { getPageProps } from 'utils/helpers/server/serverSideProps/ssrProps';
import { getPageNamespaces } from 'utils/helpers/server/serverSideProps/translations';
import PersonRecoveryPage from 'components/personRecovery/PersonRecoveryPage';

type Props = Record<string, never>;

interface ServerSideProps {
    props?: Props;
}

const Page = (): ReactElement => <PersonRecoveryPage />;

export const getServerSideProps = async ({
    req,
    res,
    query,
}: ServerSideInitProps): Promise<ServerSideProps> => {
    const { api } = await getGlobalProps(req, res, true);

    const props = await getPageProps<Props>({
        givenProps: {},
        res,
        req,
        api,
        query,
        loadUserData: false,
        translatePage: true,
        nameSpaces: getPageNamespaces('/person-recovery'),
    });

    return {
        props,
    };
};

export default Page;
